import { createAction } from 'redux-actions';
import * as labelReviewApprovalFormTypes from './labelReviewApprovalFormTypes';

export const onSaveButtonClick = createAction(labelReviewApprovalFormTypes.SAVE_BUTTON_CLICK);
